import { marked } from 'marked';

marked.use({
  gfm: true,
  breaks: true,
  renderer: {
    link({ href, title, tokens }) {
      const text = this.parser.parseInline(tokens);
      const titleAttr = title ? ' title="' + escapeAttr(title) + '"' : '';
      const safeHref = escapeAttr(href);
      return (
        '<a href="' +
        safeHref +
        '"' +
        titleAttr +
        ' target="_blank" rel="noopener noreferrer">' +
        text +
        '</a>'
      );
    }
  }
});

/** Markdown → HTML for canonical lesson bodies (learner + admin). Uses marked. */
export function renderLessonMarkdown(markdown: string): string {
  if (!markdown?.trim()) {
    return '<p>(no markdown body)</p>';
  }

  return marked.parse(markdown, { async: false }) as string;
}

function escapeAttr(value: string): string {
  return value
    .replace(/&/g, '&amp;')
    .replace(/"/g, '&quot;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
}